/**
 * Handle auth on app resume
 */
export default defineNuxtPlugin(async (nuxtApp) => {
  const localStorage = useLocalStorage();
  const settingsStore = useSettingsStore(nuxtApp.$pinia);

  const distance = localStorage.get("settings-distance");
  const histories = localStorage.get("settings-histories");

  if (distance) {
    settingsStore.distance = distance;
  }

  if (histories) {
    settingsStore.histories = histories;
  }
});
